import type { Ref } from "react";

/** Hands `value` to a forwarded ref, whether it is a callback or an object ref. */
export function assignRef<T>(ref: Ref<T> | undefined, value: T): void {
  if (typeof ref === "function") ref(value);
  else if (ref) (ref as { current: T }).current = value;
}
